import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { whatsappService } from '../../services/api';
import '../../styles/WhatsAppHistorial.css';

function Historial() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [mensajes, setMensajes] = useState([]);
  const [mensajeDetalle, setMensajeDetalle] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Filtros
  const [filtros, setFiltros] = useState({
    estado: '',
    tipo: '',
    fecha_desde: '',
    fecha_hasta: '',
    cliente_id: ''
  });

  const [estadisticas, setEstadisticas] = useState({
    total: 0,
    enviados: 0,
    pendientes: 0,
    fallidos: 0
  });

  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    cargarMensajes();
  }, [filtros]);

  const cargarMensajes = async () => {
    try {
      setLoading(true);
      const params = Object.fromEntries(
        Object.entries(filtros).filter(([_, value]) => value !== '')
      );

      const response = await whatsappService.getMensajes(params);
      const mensajesData = response.data.mensajes || [];
      setMensajes(mensajesData);

      // Calcular estadísticas
      setEstadisticas({
        total: mensajesData.length,
        enviados: mensajesData.filter(m => m.estado === 'enviado').length,
        pendientes: mensajesData.filter(m => m.estado === 'pendiente').length,
        fallidos: mensajesData.filter(m => m.estado === 'fallido').length
      });
    } catch (error) {
      console.error('Error cargando mensajes:', error);
      showMessage('error', 'Error al cargar mensajes');
    } finally {
      setLoading(false);
    }
  };

  const handleVerDetalle = async (id) => {
    try {
      const response = await whatsappService.getMensaje(id);
      setMensajeDetalle(response.data);
      setShowModal(true);
    } catch (error) {
      showMessage('error', 'Error al cargar detalle');
    }
  };

  const handleEliminar = async (id) => {
    if (!window.confirm('¿Eliminar este mensaje del historial?')) {
      return;
    }

    try {
      await whatsappService.deleteMensaje(id);
      showMessage('success', '✅ Mensaje eliminado');
      await cargarMensajes();
    } catch (error) {
      showMessage('error', 'Error al eliminar mensaje');
    }
  };

  const handleReenviar = async (mensaje) => {
    if (!window.confirm('¿Reenviar este mensaje?')) {
      return;
    }

    try {
      await whatsappService.enviarMensaje({
        cliente_id: mensaje.cliente_id,
        prestamo_id: mensaje.prestamo_id,
        tipo_mensaje: mensaje.tipo_mensaje,
        mensaje: mensaje.mensaje,
        enviar_inmediato: true
      });
      showMessage('success', '✅ Mensaje reenviado');
      await cargarMensajes();
    } catch (error) {
      showMessage('error', 'Error al reenviar mensaje');
    }
  };

  const handleLimpiarFiltros = () => {
    setFiltros({
      estado: '',
      tipo: '',
      fecha_desde: '',
      fecha_hasta: '',
      cliente_id: ''
    });
  };

  const showMessage = (type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage({ type: '', text: '' }), 5000);
  };

  const getTipoLabel = (tipo) => {
    const labels = {
      'recordatorio_pago': 'Recordatorio',
      'vencido': 'Vencido',
      'mora': 'Mora',
      'confirmacion': 'Confirmación',
      'estado_cuenta': 'Estado de Cuenta',
      'personalizado': 'Personalizado',
      'plantilla': 'Plantilla',
      'masivo': 'Masivo'
    };
    return labels[tipo] || tipo;
  };

  const getTipoIcon = (tipo) => {
    const icons = {
      'recordatorio_pago': '🔔',
      'vencido': '⚠️',
      'mora': '📈',
      'confirmacion': '✅',
      'estado_cuenta': '📊',
      'personalizado': '✉️',
      'plantilla': '📝',
      'masivo': '👥'
    };
    return icons[tipo] || '📱';
  };

  const getEstadoIcon = (estado) => {
    const icons = {
      'enviado': '✅',
      'pendiente': '⏳',
      'fallido': '❌'
    };
    return icons[estado] || '❓';
  };

  if (loading && mensajes.length === 0) {
    return (
      <div className="historial-page">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Cargando historial...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="historial-page">
      <div className="page-header">
        <div>
          <h1>📋 Historial de Mensajes</h1>
          <p className="subtitle">Consulta todos los mensajes enviados por WhatsApp</p>
        </div>
        <button onClick={() => navigate('/whatsapp')} className="btn btn-secondary">
          ← Volver
        </button>
      </div>

      {message.text && (
        <div className={`message-alert ${message.type}`}>
          {message.text}
        </div>
      )}

      {/* Estadísticas */}
      <div className="stats-row">
        <div className="stat-mini stat-total">
          <span className="stat-value">{estadisticas.total}</span>
          <span className="stat-label">Total</span>
        </div>
        <div className="stat-mini stat-enviados">
          <span className="stat-value">✅ {estadisticas.enviados}</span>
          <span className="stat-label">Enviados</span>
        </div>
        <div className="stat-mini stat-pendientes">
          <span className="stat-value">⏳ {estadisticas.pendientes}</span>
          <span className="stat-label">Pendientes</span>
        </div>
        <div className="stat-mini stat-fallidos">
          <span className="stat-value">❌ {estadisticas.fallidos}</span>
          <span className="stat-label">Fallidos</span>
        </div>
      </div>

      {/* Filtros */}
      <div className="filtros-card">
        <h3>🔍 Filtros</h3>
        <div className="filtros-grid">
          <div className="filtro-group">
            <label>Estado</label>
            <select
              value={filtros.estado}
              onChange={(e) => setFiltros({ ...filtros, estado: e.target.value })}
            >
              <option value="">Todos</option>
              <option value="enviado">Enviado</option>
              <option value="pendiente">Pendiente</option>
              <option value="fallido">Fallido</option>
            </select>
          </div>

          <div className="filtro-group">
            <label>Tipo</label>
            <select
              value={filtros.tipo}
              onChange={(e) => setFiltros({ ...filtros, tipo: e.target.value })}
            >
              <option value="">Todos</option>
              <option value="recordatorio_pago">Recordatorio</option>
              <option value="vencido">Vencido</option>
              <option value="confirmacion">Confirmación</option>
              <option value="estado_cuenta">Estado de Cuenta</option>
              <option value="personalizado">Personalizado</option>
            </select>
          </div>

          <div className="filtro-group">
            <label>Desde</label>
            <input
              type="date"
              value={filtros.fecha_desde}
              onChange={(e) => setFiltros({ ...filtros, fecha_desde: e.target.value })}
            />
          </div>

          <div className="filtro-group">
            <label>Hasta</label>
            <input
              type="date"
              value={filtros.fecha_hasta}
              onChange={(e) => setFiltros({ ...filtros, fecha_hasta: e.target.value })}
            />
          </div>
        </div>

        <button onClick={handleLimpiarFiltros} className="btn btn-outline btn-small">
          🔄 Limpiar Filtros
        </button>
      </div>

      {/* Tabla de Mensajes */}
      <div className="mensajes-table-card">
        {mensajes.length === 0 ? (
          <div className="empty-state">
            <p>📭 No hay mensajes que mostrar</p>
            {Object.values(filtros).some(f => f !== '') && (
              <button onClick={handleLimpiarFiltros} className="btn btn-primary">
                Limpiar Filtros
              </button>
            )}
          </div>
        ) : (
          <div className="table-responsive">
            <table className="mensajes-table">
              <thead>
                <tr>
                  <th>Estado</th>
                  <th>Tipo</th>
                  <th>Cliente</th>
                  <th>Teléfono</th>
                  <th>Mensaje</th>
                  <th>Fecha</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {mensajes.map((mensaje) => (
                  <tr key={mensaje.id}>
                    <td>
                      <span className={`estado-badge estado-${mensaje.estado}`}>
                        {getEstadoIcon(mensaje.estado)} {mensaje.estado}
                      </span>
                    </td>
                    <td>
                      <span className="tipo-label">
                        {getTipoIcon(mensaje.tipo_mensaje)} {getTipoLabel(mensaje.tipo_mensaje)}
                      </span>
                    </td>
                    <td>{mensaje.cliente_nombre}</td>
                    <td className="telefono">{mensaje.numero_destino}</td>
                    <td className="mensaje-preview">
                      {mensaje.mensaje.substring(0, 50)}
                      {mensaje.mensaje.length > 50 && '...'}
                    </td>
                    <td className="fecha">
                      {mensaje.fecha_enviado
                        ? new Date(mensaje.fecha_enviado).toLocaleString('es-DO')
                        : new Date(mensaje.created_at).toLocaleString('es-DO')
                      }
                    </td>
                    <td>
                      <div className="acciones-grupo">
                        <button
                          onClick={() => handleVerDetalle(mensaje.id)}
                          className="btn-icon"
                          title="Ver detalle"
                        >
                          👁️
                        </button>
                        {mensaje.estado === 'fallido' && (
                          <button
                            onClick={() => handleReenviar(mensaje)}
                            className="btn-icon"
                            title="Reenviar"
                          >
                            🔄
                          </button>
                        )}
                        <button
                          onClick={() => handleEliminar(mensaje.id)}
                          className="btn-icon btn-danger"
                          title="Eliminar"
                        >
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal Detalle */}
      {showModal && mensajeDetalle && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>📱 Detalle del Mensaje</h3>
              <button onClick={() => setShowModal(false)} className="btn-close">✕</button>
            </div>

            <div className="modal-body">
              <div className="detalle-grid">
                <div className="detalle-item">
                  <strong>ID:</strong>
                  <span>#{mensajeDetalle.id}</span>
                </div>

                <div className="detalle-item">
                  <strong>Estado:</strong>
                  <span className={`estado-badge estado-${mensajeDetalle.estado}`}>
                    {getEstadoIcon(mensajeDetalle.estado)} {mensajeDetalle.estado}
                  </span>
                </div>

                <div className="detalle-item">
                  <strong>Tipo:</strong>
                  <span>
                    {getTipoIcon(mensajeDetalle.tipo_mensaje)} {getTipoLabel(mensajeDetalle.tipo_mensaje)}
                  </span>
                </div>

                <div className="detalle-item">
                  <strong>Cliente:</strong>
                  <span>{mensajeDetalle.cliente_nombre}</span>
                </div>

                <div className="detalle-item">
                  <strong>Teléfono:</strong>
                  <span>{mensajeDetalle.numero_destino}</span>
                </div>

                {mensajeDetalle.prestamo_id && (
                  <div className="detalle-item">
                    <strong>Préstamo:</strong>
                    <span>#{mensajeDetalle.prestamo_id}</span>
                  </div>
                )}

                <div className="detalle-item">
                  <strong>Fecha Creación:</strong>
                  <span>{new Date(mensajeDetalle.created_at).toLocaleString('es-DO')}</span>
                </div>

                {mensajeDetalle.fecha_enviado && (
                  <div className="detalle-item">
                    <strong>Fecha Envío:</strong>
                    <span>{new Date(mensajeDetalle.fecha_enviado).toLocaleString('es-DO')}</span>
                  </div>
                )}

                {mensajeDetalle.creado_por && (
                  <div className="detalle-item">
                    <strong>Creado por:</strong>
                    <span>{mensajeDetalle.creado_por}</span>
                  </div>
                )}
              </div>

              <div className="mensaje-completo">
                <strong>Mensaje Completo:</strong>
                <div className="whatsapp-bubble-detalle">
                  {mensajeDetalle.mensaje}
                </div>
              </div>

              {mensajeDetalle.error_mensaje && (
                <div className="error-box">
                  <strong>⚠️ Error:</strong>
                  <p>{mensajeDetalle.error_mensaje}</p>
                </div>
              )}
            </div>

            <div className="modal-footer">
              {mensajeDetalle.estado === 'fallido' && (
                <button
                  onClick={() => {
                    handleReenviar(mensajeDetalle);
                    setShowModal(false);
                  }}
                  className="btn btn-success"
                >
                  🔄 Reenviar
                </button>
              )}
              <button onClick={() => setShowModal(false)} className="btn btn-secondary">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Historial;
